export { ReactComponent as Reset } from './svgs/reset.svg';
